export const UngroupIcon = ({ color = '#71717A' }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        fill={color}
        d="M3.8 9.133 2.867 8.2l2.866-2.867h-2.4V4H8v4.667H6.667v-2.4zM10.667 6V1.333H6V0h6v6zm-9.334 6q-.55 0-.941-.391A1.29 1.29 0 0 1 0 10.667V0h1.333v10.667H12V12z"
      />
    </svg>
  )
}
